import FullContainerCardFormatter from 'crm-cards-sdk/card-formatters/FullContainerCardFormatter';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import devLogger from 'react-utils/devLogger';
import { CardContainerContextProvider } from 'crm-cards-sdk/internal/CardContainerContext';
import Raven from 'raven-js';
import { useEffect } from 'react';
import LinkCardActionButtonList from 'crm-cards-sdk/action-formatters/LinkCardActionButtonList';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SingleCardContainerFormatter({
  contents,
  CrmContainerContentRenderer,
  containerId,
  observerManager,
  CardFormatter = FullContainerCardFormatter
}) {
  useEffect(() => {
    if (contents.length !== 1) {
      devLogger.warn({
        key: `SingleCardContainerFormatter:MultipleItems:ContainerId=${containerId}`,
        message: 'SingleCardContainerFormatter received multiple items. Not rendering any.'
      });
      Raven.captureException(new Error('SingleCardContainerFormatter received multiple items. Not rendering any.'), {
        extra: {
          contents
        }
      });
    }
  }, [contents, containerId]);
  if (contents.length !== 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(CardContainerContextProvider, {
    value: {
      DefaultCardFormatter: CardFormatter,
      reorderable: false,
      observerManager,
      ActionFormatter: LinkCardActionButtonList
    },
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "stretch",
      blockSize: "100%",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(Box, {
        grow: 1,
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(CrmContainerContentRenderer, {
          content: contents[0]
        })
      })
    })
  });
}